// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2y4DE","footerLabel":"Footer_footerLabel__3KtwC"};